import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconPhoto from 'components/icons/iconPhoto';
import IconUpload from 'components/icons/IconUpload';
import { colorBrand } from 'styles/layout/colors';
const DropzoneUploadLabel = t0 => {
  const $ = _c(10);
  const {
    allowMultiple: t1,
    allowVideos: t2,
    subLabel: t3
  } = t0;
  const allowMultiple = t1 === undefined ? true : t1;
  const allowVideos = t2 === undefined ? true : t2;
  const subLabel = t3 === undefined ? "" : t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconPhoto color={colorBrand} className="md:hidden" />;
    t5 = <IconUpload color={colorBrand} className="max-[767px]:hidden" />;
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  const t6 = `Take a photo${allowVideos ? ", video" : ""} or upload from your library`;
  let t7;
  if ($[2] !== t6) {
    t7 = <span className="md:hidden">{t6}</span>;
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = `Choose photo${allowMultiple ? "s" : ""}${allowVideos ? "/video" : ""} or drag and drop here`;
  let t9;
  if ($[4] !== t8) {
    t9 = <span className="max-[767px]:hidden">{t8}</span>;
    $[4] = t8;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== subLabel || $[7] !== t7 || $[8] !== t9) {
    t10 = <div className="text-xs font-bold items-center text-brand flex flex-col justify-center px-4 py-6 [&_svg]:h-[30px] [&_svg]:mb-[5px] [&_svg]:align-middle [&_svg]:w-[35px]">{t4}{t5}<span>{t7}{t9}{subLabel}</span></div>;
    $[6] = subLabel;
    $[7] = t7;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  return t10;
};
DropzoneUploadLabel.propTypes = {
  allowMultiple: PropTypes.bool,
  allowVideos: PropTypes.bool,
  subLabel: PropTypes.string
};
export default DropzoneUploadLabel;